import { c as _c } from "react/compiler-runtime";
// «Мои адреса» (список сохранённых адресов с правкой/удалением) и
// «Редактировать адрес» (Город, улица, дом / Квартира / Этаж / Подъезд /
// Домофон / Комментарий для курьера) — кадры 10–11 макета «5.1 Оформление
// заказа-2». Та же форма без модалки — в полноэкранном выборе доставки.
import { Edit20Icon, TrashIcon } from "@/components/icons";
import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { api, type AddressSuggestion, type BuyerAddress, type BuyerAddressInput } from "@/api";
import { CheckoutModal, IconAction, ListRow, ModalButton, ModalField } from "./ui";
export type CourierAddressValues = {
  line: string; // «Город, улица, дом» одной строкой
  country: string;
  city: string;
  street: string;
  postalCode: string;
  apartment: string;
  floor: string;
  entrance: string;
  intercom: string;
  comment: string;
};
export const emptyCourierAddress = (): CourierAddressValues => ({
  line: "",
  country: "Россия",
  city: "",
  street: "",
  postalCode: "",
  apartment: "",
  floor: "",
  entrance: "",
  intercom: "",
  comment: ""
});
export const courierValuesFromAddress = (a: BuyerAddress): CourierAddressValues => ({
  line: [a.city, a.street].filter(Boolean).join(", "),
  country: a.country,
  city: a.city,
  street: a.street,
  postalCode: a.postalCode,
  apartment: a.apartment ?? "",
  floor: a.floor ?? "",
  entrance: a.entrance ?? "",
  intercom: a.intercom ?? "",
  comment: a.comment
});

// Строка «Город, улица, дом» без выбора подсказки — делим по первой запятой.
const splitLine = (v: CourierAddressValues): CourierAddressValues => {
  if (v.city && v.street && v.line === [v.city, v.street].join(", ")) return v;
  const [city = "", ...rest] = v.line.split(",").map(s => s.trim());
  return {
    ...v,
    city: rest.length ? city : v.city || city,
    street: rest.length ? rest.join(", ") : v.street || ""
  };
};
export const courierAddressInput = (raw: CourierAddressValues, contact: {
  recipient: string;
  phone: string;
}, isDefault = false): BuyerAddressInput => {
  const v = splitLine(raw);
  return {
    label: v.street,
    recipient: contact.recipient,
    phone: contact.phone,
    country: v.country || "Россия",
    city: v.city,
    street: v.street,
    postalCode: v.postalCode,
    comment: v.comment,
    isDefault,
    apartment: v.apartment,
    floor: v.floor,
    entrance: v.entrance,
    intercom: v.intercom
  };
};

// Короткая подпись адреса для строк/шапки: «ул …, д 1/2, кв. 100, эт. 5».
export const courierAddressLabel = (a: Pick<BuyerAddress, "street" | "apartment" | "floor">): string => [a.street, a.apartment ? `кв. ${a.apartment}` : "", a.floor ? `эт. ${a.floor}` : ""].filter(Boolean).join(", ");
export function AddressListModal(t0) {
  const $ = _c(15);
  const {
    open,
    onOpenChange,
    addresses,
    selectedId,
    onSelect,
    onAdd,
    onEdit,
    onChanged
  } = t0;
  let t1;
  if ($[0] !== onChanged) {
    t1 = async a => {
      ;
      try {
        await api.buyer.deleteAddress(a.id);
        onChanged();
      } catch (t2) {
        const e = t2;
        toast.error(e instanceof Error ? e.message : "\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0430\u0434\u0440\u0435\u0441");
      }
    };
    $[0] = onChanged;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const remove = t1;
  let t2;
  if ($[2] !== addresses || $[3] !== onEdit || $[4] !== onSelect || $[5] !== remove || $[6] !== selectedId) {
    t2 = addresses.length > 0 && <div className="mb-5 flex flex-col rounded-[12px] bg-[#F8F8F8]">{addresses.map(a_0 => <ListRow key={a_0.id} selected={a_0.id === selectedId} onSelect={() => onSelect(a_0)} actions={<><IconAction label={"\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0430\u0434\u0440\u0435\u0441"} onClick={() => onEdit(a_0)}><Edit20Icon size={20} /></IconAction><IconAction label={"\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0430\u0434\u0440\u0435\u0441"} onClick={() => void remove(a_0)}><TrashIcon size={20} /></IconAction></>}>{courierAddressLabel(a_0)}</ListRow>)}</div>;
    $[2] = addresses;
    $[3] = onEdit;
    $[4] = onSelect;
    $[5] = remove;
    $[6] = selectedId;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== onAdd) {
    t3 = <ModalButton onClick={onAdd} data-testid="address-add">Добавить адрес</ModalButton>;
    $[8] = onAdd;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== onOpenChange || $[11] !== open || $[12] !== t2 || $[13] !== t3) {
    t4 = <CheckoutModal open={open} onOpenChange={onOpenChange} title={"\u041C\u043E\u0438 \u0430\u0434\u0440\u0435\u0441\u0430"} testId="address-list-modal">{t2}{t3}</CheckoutModal>;
    $[10] = onOpenChange;
    $[11] = open;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}

// Поля курьерского адреса (общие для модалки и полноэкранного выбора).
export function CourierAddressFields(t0) {
  const $ = _c(43);
  const {
    value,
    onChange,
    compact
  } = t0;
  let t1;
  if ($[0] !== onChange || $[1] !== value) {
    t1 = patch => onChange({
      ...value,
      ...patch
    });
    $[0] = onChange;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const set = t1;
  const gap = compact ? "gap-2.5" : "gap-3";
  const t2 = `flex flex-col ${gap}`;
  let t3;
  if ($[3] !== onChange || $[4] !== value) {
    t3 = <AddressLineField value={value} onChange={onChange} />;
    $[3] = onChange;
    $[4] = value;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== set) {
    t4 = apartment => set({
      apartment
    });
    $[6] = set;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4 || $[9] !== value.apartment) {
    t5 = <ModalField label={"\u041A\u0432\u0430\u0440\u0442\u0438\u0440\u0430"} value={value.apartment} onChange={t4} />;
    $[8] = t4;
    $[9] = value.apartment;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== set) {
    t6 = floor => set({
      floor
    });
    $[11] = set;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6 || $[14] !== value.floor) {
    t7 = <ModalField label={"\u042D\u0442\u0430\u0436"} value={value.floor} inputMode="numeric" onChange={t6} />;
    $[13] = t6;
    $[14] = value.floor;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t5 || $[17] !== t7) {
    t8 = <div className="grid grid-cols-2 gap-3">{t5}{t7}</div>;
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== set) {
    t9 = entrance => set({
      entrance
    });
    $[19] = set;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t9 || $[22] !== value.entrance) {
    t10 = <ModalField label={"\u041F\u043E\u0434\u044A\u0435\u0437\u0434"} value={value.entrance} inputMode="numeric" onChange={t9} />;
    $[21] = t9;
    $[22] = value.entrance;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== set) {
    t11 = intercom => set({
      intercom
    });
    $[24] = set;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== value.intercom) {
    t12 = <ModalField label={"\u0414\u043E\u043C\u043E\u0444\u043E\u043D"} value={value.intercom} onChange={t11} />;
    $[26] = t11;
    $[27] = value.intercom;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t10 || $[30] !== t12) {
    t13 = <div className="grid grid-cols-2 gap-3">{t10}{t12}</div>;
    $[29] = t10;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== set) {
    t14 = comment => set({
      comment
    });
    $[32] = set;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t14 || $[35] !== value.comment) {
    t15 = <ModalField label={"\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439 \u0434\u043B\u044F \u043A\u0443\u0440\u044C\u0435\u0440\u0430"} value={value.comment} onChange={t14} />;
    $[34] = t14;
    $[35] = value.comment;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t13 || $[38] !== t15 || $[39] !== t2 || $[40] !== t3 || $[41] !== t8) {
    t16 = <div className={t2}>{t3}{t8}{t13}{t15}</div>;
    $[37] = t13;
    $[38] = t15;
    $[39] = t2;
    $[40] = t3;
    $[41] = t8;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  return t16;
}

// «Город, улица, дом» с подсказками адреса (DaData через шлюз; без ключа —
// ручной ввод, город/улица делятся по первой запятой).
function AddressLineField(t0) {
  const $ = _c(21);
  const {
    value,
    onChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [items, setItems] = useState(t1);
  const [open, setOpen] = useState(false);
  const reqId = useRef(0);
  let t2;
  if ($[1] !== value.line) {
    t2 = value.line.trim();
    $[1] = value.line;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const q = t2;
  let t3;
  let t4;
  if ($[3] !== q) {
    t3 = () => {
      if (q.length < 3) {
        setItems([]);
        return;
      }
      const id = reqId.current = reqId.current + 1;
      const t = setTimeout(() => {
        api.geo.addressSuggest(q).then(r => {
          if (id === reqId.current) {
            setItems(r.slice(0, 6));
          }
        }).catch(_temp);
      }, 250);
      return () => clearTimeout(t);
    };
    t4 = [q];
    $[3] = q;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  if ($[6] !== onChange || $[7] !== value) {
    t5 = line => {
      setOpen(true);
      onChange({
        ...value,
        line,
        city: "",
        street: ""
      });
    };
    $[6] = onChange;
    $[7] = value;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setTimeout(() => setOpen(false), 150);
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== value.line) {
    t7 = <ModalField label={"\u0413\u043E\u0440\u043E\u0434, \u0443\u043B\u0438\u0446\u0430, \u0434\u043E\u043C"} value={value.line} testId="address-line" onChange={t5} onBlur={t6} />;
    $[10] = t5;
    $[11] = value.line;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== items || $[14] !== onChange || $[15] !== open || $[16] !== value) {
    t8 = open && items.length > 0 && <ul className="absolute top-full right-0 left-0 z-10 mt-1 max-h-60 overflow-auto rounded-[10px] bg-white p-1 shadow-[0_4px_24px_rgba(0,0,0,0.12)]">{items.map(s => <li key={s.value}><button type="button" onMouseDown={_temp2} onClick={() => {
          setOpen(false);
          onChange({
            ...value,
            line: s.value,
            country: s.country || value.country,
            city: s.city,
            street: s.street,
            postalCode: s.postalCode
          });
        }} className="w-full rounded-[8px] px-3 py-2.5 text-left text-[14px] text-[#1F1F1F] hover:bg-[#F8F8F8]">{s.value}</button></li>)}</ul>;
    $[13] = items;
    $[14] = onChange;
    $[15] = open;
    $[16] = value;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <div className="relative">{t7}{t8}</div>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
}
function _temp2(e) {
  return e.preventDefault();
}
function _temp() {}
export function AddressEditModal({
  open,
  onOpenChange,
  address,
  contact,
  onSaved
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  address: BuyerAddress | null;
  contact: {
    recipient: string;
    phone: string;
  };
  onSaved: (a: BuyerAddress) => void;
}) {
  const [value, setValue] = useState<CourierAddressValues>(emptyCourierAddress);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (open) setValue(address ? courierValuesFromAddress(address) : emptyCourierAddress());
  }, [open, address]);
  const save = async () => {
    const input = courierAddressInput(value, contact, address?.isDefault ?? false);
    if (!input.city || !input.street) {
      toast.error("Укажите город, улицу и дом через запятую");
      return;
    }
    setBusy(true);
    try {
      const saved = address ? await api.buyer.updateAddress(address.id, input) : await api.buyer.createAddress(input);
      onSaved(saved);
    } catch (e) {
      toast.error(e instanceof Error ? e.message : "Не удалось сохранить адрес");
    } finally {
      setBusy(false);
    }
  };
  return <CheckoutModal open={open} onOpenChange={onOpenChange} title={address ? "Редактировать адрес" : "Добавить адрес"} testId="address-edit-modal">
			<CourierAddressFields value={value} onChange={setValue} />
			<ModalButton className="mt-5" disabled={busy} onClick={() => void save()} data-testid="address-save">
				Сохранить
			</ModalButton>
		</CheckoutModal>;
}